import { render } from "./SoloTraderIcon.vue?vue&type=template&id=71faa089"
import script from "./SoloTraderIcon.vue?vue&type=script&lang=js"
export * from "./SoloTraderIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__